/**
 * Request History LOV (List of Values) Options
 * This file contains all static LOV options used in Request History components
 */

// Tab Updated LOV options for Request Form History (OPEN/Rave)
export const TAB_UPDATED_OPTIONS = [
  { label: "Protocol Information", value: "Protocol Information" },
  { label: "OPEN Setup", value: "OPEN Setup" },
  { label: "Rave Setup", value: "Rave Setup" },
  { label: "Signoff: Submitted", value: "Signoff: Submitted" },
  { label: "Signoff: UAT Setup", value: "Signoff: UAT Setup" },
  { label: "Signoff: Group Testing", value: "Signoff: Group Testing" },
  { label: "Signoff: CTSU Testing", value: "Signoff: CTSU Testing" },
  { label: "Signoff: Pending Signoff", value: "Signoff: Pending Signoff" },
  { label: "Signoff: Completed", value: "Signoff: Completed" }
];

// Tab Updated LOV options for Regulatory Request Form History
export const TAB_UPDATED_REGULATORY_OPTIONS = [
  { label: "Protocol Information", value: "Protocol Information" },
  { label: "Regulatory Setup", value: "Regulatory Setup" },
  { label: "Signoff: Submitted", value: "Signoff: Submitted" },
  { label: "Signoff: In Progress", value: "Signoff: In Progress" },
  { label: "Signoff: Completed", value: "Signoff: Completed" }
];

// User Action LOV options for Status History
export const USER_ACTION_OPTIONS = [
  { label: "Initial Save", value: "INITIAL_SAVE" },
  { label: "Submit", value: "SUBMIT" },
  { label: "Signoff", value: "SIGNOFF" },
  { label: "Retired", value: "RETIRED" },
  { label: "Canceled", value: "CANCELED" },
  { label: "Auto-Retired", value: "AUTO_RETIRED" }
];

// Updated Status LOV options for Status History
export const UPDATED_STATUS_OPTIONS = [
  { label: "Draft", value: "DRAFT" },
  { label: "Submitted", value: "SUBMITTED" },
  { label: "UAT Setup", value: "UAT_SETUP" },
  { label: "Group Testing", value: "GROUP_TESTING" },
  { label: "CTSU Testing", value: "CTSU_TESTING" },
  { label: "Pending Signoff", value: "PENDING_SIGNOFF" },
  { label: "Completed", value: "COMPLETED" },
  { label: "Retired", value: "RETIRED" },
  { label: "Canceled", value: "CANCELED" },
  { label: "In Progress", value: "IN_PROGRESS" }
];
